export default __webpack_public_path__ + "static/media/Contact.dd9ead25.png";